import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import config from '../utils/config';
import { baseQueryWithInterceptor } from './baseQueryWithInterceptor';


export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithInterceptor,
  endpoints: () => ({}), 
});